import { useMemo } from 'react'
import { isNil } from 'ramda'

/**
 *
 * @param {*} value
 * @param {Object} rules yup schema
 * @returns {Array} isValid boolean, errors array
 *
 * @example
 *    const [isValid, errors] = useValidate('abc', yup.string())
 */

const useValidate = (value, rules) => {
  const stringifiedContext = JSON.stringify(rules.context)

  // must stay, need to update when context changes
  /* eslint-disable react-hooks/exhaustive-deps */
  const result = useMemo(() => {
    try {
      rules.validateSync(value, { strict: true, context: rules.context })
      return null
    } catch (err) {
      return err.errors
    }
  }, [value, rules, stringifiedContext])

  return [isNil(result), result]
}

export default useValidate
